<template>
  <div class="row justify-center">
      <div class="card text-center px-1 py-2 m-auto" style="width:25rem;">
        <img class="card-img-top py-3 px-5" src="../assets/images/logo-aequaroma.jpg" alt="AEqua Roma" >
        <h6>Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale</h6>
        <h4>Modifica password</h4>
        <div class="d-flex flex-column card-body">
          <b-input-group>
            <b-input v-model="oldPassword" :type="oldPasswordFieldType" placeholder="Password attuale" class="m-1" />
            <b-input-group-append>
              <font-awesome-icon :icon="oldPasswordfieldIcon" size="lg" class="text-primary cursor-pointer align-self-center" @click="showOldPassword()"/>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input v-model="newPassword" :type="newPasswordFieldType" placeholder="Nuova password" class="m-1" aria-required="true"  title=" Lunghezza minima 8 caratteri, di cui almeno un numero, un carattere maiuscolo e uno minuscolo" :state="fieldNewPassword" />
            <b-input-group-append>
              <font-awesome-icon :icon="newPasswordfieldIcon" size="lg" class="text-primary cursor-pointer align-self-center" @click="showNewPassword()"/>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input v-model="confirmPassword" :type="confirmPasswordFieldType" placeholder="Conferma password" class="m-1" aria-required="true" data-vv-as="newPassword" :state="fieldConfirmPassword" />
            <b-input-group-append>
              <font-awesome-icon :icon="confirmPasswordfieldIcon" size="lg" class="text-primary cursor-pointer align-self-center" @click="showConfirmPassword()"/>
            </b-input-group-append>
          </b-input-group>
          <label class="text">Lunghezza minima 8 caratteri, di cui almeno un numero, un carattere maiuscolo e uno minuscolo.</label>
          <b-button variant="primary" size="lg" class="m-1" @click="onChangeClick">Cambia</b-button>
          <b-button variant="outline-secondary" size="lg" class="m-1" @click="onCancelClick">Annulla</b-button>
        </div>
      </div>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'

const validatePassword = (value, vm) => {
  var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
  let retValue = false

  // console.log('value', value)
  // console.log('test value', re.test(value))
  if (re.test(value)) {
    retValue = true
  }

  return retValue
}

export default {

  data: () => {
    return {
      checking: true,
      base: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      oldPasswordFieldType: 'password',
      newPasswordFieldType: 'password',
      confirmPasswordFieldType: 'password',
      oldPasswordfieldIcon: 'eye-slash',
      newPasswordfieldIcon: 'eye-slash',
      confirmPasswordfieldIcon: 'eye-slash'
    }
  },
  validations: {
    newPassword: { required, validatePassword },
    confirmPassword: { required, sameAsPassword: sameAs('newPassword') }
  },

  computed: {
    fieldNewPassword () {
      this.$v.newPassword.$touch()

      return !this.$v.newPassword.$invalid
    },
    fieldConfirmPassword () {
      this.$v.confirmPassword.$touch()

      return !this.$v.confirmPassword.$invalid && !this.$v.newPassword.$invalid
    }

  },

  methods: {
    onCancelClick () {
      this.$router.push({ name: 'home' })
    },
    async onChangeClick () {
      try {
        if (this.validate()) {
          await this.$store.dispatch('changePassword', { attualePassword: this.oldPassword, nuovaPassword: this.newPassword, confermaPassword: this.confirmPassword })
          // await this.$store.dispatch('changePassword')
          this.$ui.notify({
            type: 'info',
            title: 'Operazione completata',
            message: 'La password è stata modificata in modo corretto.'
          })
          // console.log('First LOGON value', this.$store.state.auth.user.firstlogon)
          this.$store.state.auth.user.firstlogon = false
          this.$router.push({ name: 'home' })
        } else {
          if (this.$v.newPassword.$invalid) {
            // Il formato della nuova password non è corretto
            // console.log('Nuova password non corretta', !this.$v.newPassword.$invalid)
            this.$ui.notify({
              type: 'warning',
              title: 'Nuova password non corretta',
              message: 'La nuova password inserita non rispetta le regole previste (Lunghezza minima 8 caratteri, di cui almeno un numero, un carattere maiuscolo e uno minuscolo).'
            })
          } else if (this.$v.confirmPassword.$invalid) {
            // Password di conferma diversa
            // console.log('Conferma password non corretta', !this.$v.confirmPassword.$invalid)
            this.$ui.notify({
              type: 'warning',
              title: 'Conferma password non corretta',
              message: 'La password di conferma inserita è diversa dalla nuova password.'
            })
          }
        }
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    validate () {
      this.$v.newPassword.$touch()
      this.$v.confirmPassword.$touch()

      return !this.$v.newPassword.$invalid && !this.$v.confirmPassword.$invalid
    },
    showOldPassword () {
      // console.log('oldPasswordFieldType', this.oldPasswordFieldType, this.newPasswordFieldType, this.confirmPasswordFieldType)
      if (this.oldPasswordFieldType === 'password') {
        this.oldPasswordFieldType = 'text'
        this.oldPasswordfieldIcon = 'eye'
      } else {
        this.oldPasswordFieldType = 'password'
        this.oldPasswordfieldIcon = 'eye-slash'
      }
    },
    showNewPassword () {
      // console.log('newPasswordFieldType', this.oldPasswordFieldType, this.newPasswordFieldType, this.confirmPasswordFieldType)
      if (this.newPasswordFieldType === 'password') {
        this.newPasswordFieldType = 'text'
        this.newPasswordfieldIcon = 'eye'
      } else {
        this.newPasswordFieldType = 'password'
        this.newPasswordfieldIcon = 'eye-slash'
      }
    },
    showConfirmPassword () {
      // console.log('confirmPasswordFieldType', this.oldPasswordFieldType, this.newPasswordFieldType, this.confirmPasswordFieldType)
      if (this.confirmPasswordFieldType === 'password') {
        this.confirmPasswordFieldType = 'text'
        this.confirmPasswordfieldIcon = 'eye'
      } else {
        this.confirmPasswordFieldType = 'password'
        this.confirmPasswordfieldIcon = 'eye-slash'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
